import type { CSSProperties } from 'react';

export const CONDENSED_BUTTON_FONT_FIX = { '--button-fz': 'var(--mantine-font-size-sm)' } as CSSProperties;
